<template>
  <div>
    <div class="login-box"> 
      <div class="login-logo">
        <!-- <router-link to="/home"><b style="color:rgb(244, 167, 21)">MICRO</b>-MUNEEM</router-link> -->
        <router-link v-if="myhost === 'hoodafinancehrm.com'" to="/home"></router-link>        
        <router-link v-else to="/home">
          <img src="https://demo.microfinsoftware.com/MicroMuneem-Logo.webp" width="200px">
        </router-link>        
      </div>
      <!-- /.login-logo -->
      <div class="login-box-body text-center" v-if="this.type === 'login'" style="border-radius:10px; box-shadow: 0px 0px 10px gray;">
        <router-link v-if="logo" to="/home"><img :src="logo" width="155px"></router-link>        
        <p class="login-box-msg text-blue">Sign in to start your session</p>
        <form @submit.prevent="login">
          <div class="form-group has-feedback">
            <label class="radio-inline">
              <input type="radio" name="type" value="email" v-model="form.type" checked required>Email
            </label>
            <label class="radio-inline">
              <input type="radio" name="type" value="mobile" v-model="form.type" required>Mobile
            </label>
            <label class="radio-inline">
              <input type="radio" name="type" value="code" v-model="form.type" required>User Code
            </label>
            <input v-if="form.type == 'email'" v-model="form.email" name="email" type="email" class="form-control" placeholder="Email" required>
            <input v-if="form.type == 'mobile'" v-model="form.mobile" name="mobile" type="number" class="form-control" placeholder="Mobile Number" required>
            <input v-if="form.type == 'code'" v-model="form.code" name="code" type="text" class="form-control" placeholder="Code Number" required>
            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
          </div>
          <div class="form-group has-feedback">
            <input v-model="form.password" name="password" type="password" class="form-control" placeholder="Password" required>
            <span class="glyphicon glyphicon-lock form-control-feedback" ></span>
          </div>
          <span v-show="error.error" class="text-danger"> Credentials that you've entered is {{error.error}}</span>
          <div class="row">
            <div class="col-xs-8">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked>
                <label class="form-check-label" for="flexCheckChecked">
                  Remember Me
                </label>
              </div>
            </div>
            <!-- /.col -->
            <div class="col-xs-4">
              <button type="submit" class="btn btn-danger btn-block btn-flat">Sign In</button>
            </div>
            <!-- /.col -->
          </div>
        </form>

        <!-- <div class="social-auth-links text-center">
          <p>- OR -</p>
          <a href="#" class="btn btn-block btn-social btn-facebook btn-flat"><i class="fa fa-facebook"></i> Sign in using
            Facebook</a>
          <a href="#" class="btn btn-block btn-social btn-google btn-flat"><i class="fa fa-google-plus"></i> Sign in using
            Google+</a>
        </div> -->
        <!-- /.social-auth-links -->
        <a href="#" @click="forgetPassword"><i class="fa fa-key"></i> Forgot Password</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <!-- <a href="https://www.youtube.com/c/TopperSolution" class="text-center" style="color:red;font-size:24px;font-weight:bold;"> <i class="fa fa-youtube fa-2x" style="color:red"> </i> Videos</a>
       <a href="https://www.youtube.com/channel/UCzNOuuBWkSIotvrkbmQCJuw" class="text-center" style="color:red;font-size:24px;font-weight:bold;"> <i class="fa fa-youtube fa-2x" style="color:red"> </i> Videos</a> -->

      </div>
      <!-- /.login-box-body -->

      <div class="login-box-body text-center" v-if="this.type === 'forget'" style="border-radius: 10px; box-shadow: gray 0px 0px 10px;">
        <router-link v-if="logo" to="/home"><img :src="logo" width="155px"></router-link>
        <p class="login-box-msg">Please Enter Registered Email/Mobile Number</p>
        <form @submit.prevent="verifyMobile">
          <label class="radio-inline">
            <input type="radio" name="type" value="email" v-model="form.type" checked required>Email
          </label>
          <label class="radio-inline">
            <input type="radio" name="type" value="mobile" v-model="form.type" required>Mobile
          </label>
          <label class="radio-inline">
            <input type="radio" name="type" value="code" v-model="form.type" required>Code
          </label>
          <br>
          <div class="form-group has-feedback">            
            <!-- <input type="hidden" v-model="form.type" name="type" value="mobile"> -->
            <input v-if="form.type == 'email'" v-model="form.email" name="email" type="email" class="form-control" placeholder="abc@gmail.com" required>
            <input v-if="form.type == 'mobile'" v-model="form.mobile" name="mobile" type="number" class="form-control" placeholder="Mobile Number" required>
            <input v-if="form.type == 'code'" v-model="form.code" name="code" type="text" class="form-control" placeholder="code" required>
            <span class="glyphicon glyphicon-phone form-control-feedback"></span>
          </div>
          <span v-show="error.error" class="text-danger">Credentials that you've entered is {{error.error}}</span>
          <div class="row">
            <div class="col-xs-8">
              <a href="#" @click="backLogin"><i class="fa fa-user"></i> Back to login</a>
            </div>
            <!-- /.col -->
            <div class="col-xs-4">
              <button type="submit" class="btn btn-primary btn-block btn-flat">Send OTP</button>
            </div>
            <!-- /.col -->
            
          </div>
        </form>
       
      </div>
      <!-- /Mobile-Verify-box-body -->

      <div class="login-box-body text-center" v-if="this.type === 'otp'" style="border-radius:10px; box-shadow: 0px 0px 10px gray;">
        <router-link v-if="logo" to="/home"><img :src="logo" width="155px"></router-link>
        <p class="login-box-msg">Please Enter One Time Password (OTP)</p>
        <form @submit.prevent="verifyOTP">
          <div class="form-group has-feedback">
            <input v-model="form.otp" name="otp" type="number" class="form-control" placeholder="Please Enter OTP" required>
            <span class="glyphicon glyphicon-phone form-control-feedback"></span>
          </div>
          <span v-show="error.error" class="text-danger"> Credentials that you've entered is {{error.error}}</span>
          <div class="row">
            <div class="col-xs-8">
              <a href="#" @click="forgetPassword"><i class="fa fa-user"></i> Resend OTP</a>
              <a href="#" @click="backLogin"><i class="fa fa-user"></i> Back to login</a>
            </div>
            <!-- /.col -->
            <div class="col-xs-4">
              <button type="submit" class="btn btn-primary btn-block btn-flat">Verify OTP</button>
            </div>
            <!-- /.col -->
            
          </div>
        </form>
       
      </div>
      <!-- /Mobile-Verify-box-body -->

      <div class="login-box-body" v-if="this.type === 'confirmPassword'">
        <p class="login-box-msg">Please Enter Password</p>
        <form @submit.prevent="confirmPassword">
          <div class="form-group has-feedback">
            <input v-model="form.password" name="password" type="password" class="form-control" placeholder="Password" required>
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
          </div>
          <div class="form-group has-feedback">
            <input v-model="form.confirm_password" name="confirm_password" type="password" class="form-control" placeholder="Confirm Password" required>
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
          </div>
          <span v-show="error.error" class="text-danger"> The password that you've entered is {{error.error}}</span>
          <div class="row">
            <div class="col-xs-6">
              <a href="#" @click="backLogin"><i class="fa fa-user"></i> Back to login</a>
            </div>
            <!-- /.col -->
            <div class="col-xs-6">
              <button type="submit" class="btn btn-primary btn-block btn-flat">Reset Password</button>
            </div>
            <!-- /.col -->
            
          </div>
        </form>
       
      </div>
    </div>
    
  </div>
</template>


<script>
// import { mapState, mapActions } from 'vuex'
export default {
  name: 'login',
  data () {
    return {
      logo: null,
      type: 'login',
      myhost: location.host,
      form: {
        id: '',
        email: null,
        password: null,
        confirm_password: null,
        mobile: '',
        type: 'email',
        otp: ''
      },
      error: {'error': null}
    }
  },
  methods: {
    forgetPassword () {
      this.type = 'forget'
    },
    backLogin () {
      this.type = 'login'
    },
    verifyMobile () {
      this.$axios.post('auth/sendotp', this.form).then(response => response.data).then(data => {
        Swal.fire({
          position: 'top-end',
          icon: 'info',
          title: 'OTP Message has been send on your Mobile Number, Please Check Your Mobile',
          showConfirmButton: false,
          timer: 1500
        })
        this.type = 'otp'
      }).catch(function (error) {
        this.error = error.response.data
        // Swal.fire('Oops...', 'Something went wrong!', 'error')
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Oops...! Something went wrong.',
          showConfirmButton: false,
          timer: 1500
        })
      }.bind(this))
    },
    verifyOTP () {
      this.$axios.post('auth/verifyotp', this.form).then(response => response.data).then(data => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'One Time Password (OTP) Verify Successfully',
          showConfirmButton: false,
          timer: 1500
        })
        this.form.id = data.data.id
        this.type = 'confirmPassword'
      }).catch(function (error) {
        this.error = error.response.data
        // Swal.fire('Oops...', 'Something went wrong!', 'error')
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Oops...! Something went wrong.',
          showConfirmButton: false,
          timer: 1500
        })
      }.bind(this))
    },
    confirmPassword () {
      this.$axios.post('auth/resetpassword', this.form).then(response => response.data).then(data => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Password Updated Successfully',
          showConfirmButton: false,
          timer: 1500
        })
        this.type = 'login'
      }).catch(function (error) {
        this.error = error.response.data
        // Swal.fire('Oops...', 'Something went wrong!', 'error')
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Oops...! Something went wrong.',
          showConfirmButton: false,
          timer: 1500
        })
      }.bind(this))
    },
    login: function () {
      // this.form.confirm_password = this.form.password
      // this.form['Client secret'] = 'vRQMRTG8nxf9cwOqBk4S2qACgAKFzmaTGWBuKDw5'
      this.$axios.post('auth/login', this.form).then(response => response.data).then(data => {
        localStorage.token = data.token
        this.$store.state.loggedIn = true
        // console.log(data)
        // Swal.fire('Welcome', 'User loggen-in successfully!', 'success')
        this.$axios.get('/auth/getuser', { headers: {'Authorization': 'Bearer ' + localStorage.token} }).then(response => response.data).then(data => {
          console.log(data)
          this.$store.state.user = data.user
          this.$store.state.currentUser = data.user
          this.$store.state.permissions = data.permissions
          this.$store.state.profile = data.profile
          this.$store.state.loggedIn = true
          this.$store.state.api_token = localStorage.token
          localStorage.permissions = data.permissions // set permissions in local storage memory
          localStorage.user = JSON.stringify(data.user)
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Welcome Log in succssfully.',
            showConfirmButton: false,
            timer: 1500
          })
          window.location.reload()
        }).catch(function (error) {
          console.log(error)
          this.error = error.response.data
        }.bind(this))
        // window.location.reload()
        // this.$router.push({'path': '/'})
      }).catch(function (error) {
        this.error = error.response.data
        // Swal.fire('Oops...', 'Something went wrong!', 'error')
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Oops...! Something went wrong.',
          showConfirmButton: false,
          timer: 1500
        })
      }.bind(this))
      loader.hide()
    }
  },
  created () {
    $('body').addClass('login-page').removeClass('skin-blue sidebar-mini')
    if (localStorage.token) {
      this.$router.push({'path': '/'})
    }
    this.$axios
        .get('getlogo')
        .then((response) => {
          if (response.data.logo) {
            this.logo = response.data.logo
          }
        })
  },
  beforeRouteLeave (to, from, next) {
    $('body').addClass('skin-blue sidebar-mini').removeClass('login-page')
    next()
  }
}
</script>

<style>
.login-page {
  background-color: #ecf0f5;
  z-index: 800;
}
</style>



// WEBPACK FOOTER //
// login.vue?3dfef50c